export class SelectionRuleFilter {
    public IncludeInactive?: boolean;
}

export default SelectionRuleFilter;